import { create, all, ConfigOptions } from "mathjs";
const config: ConfigOptions = {
  number: "BigNumber",
  precision: 14
};
const math = create(all, config);

//开方
export const numberSqrt = (arg1: number) => math.sqrt(arg1);
//除
export const numberExcept = (arg1: number, arg2: number) => math.divide(arg1, arg2);
//乘
export const numberRide = (arg1: number, arg2: number) => math.multiply(arg1, arg2);
//加
export const numberAdd = (arg1: number, arg2: number) => math.add(arg1, arg2);
//减
export const numberSub = (arg1: number, arg2: number) => math.add(arg1, -arg2);

export function formatValue(value: number) {
  const precision = 14;
  return Number(math.format(value, precision));
}
